import React from 'react';

const AboutStats = () => {
  const stats = [
    { value: '$6B', label: 'Loan Transactions Supported', suffix: '+' },
    { value: '1000', label: 'Leases Abstracted', suffix: '+' },
    { value: '15', label: 'Clients Across USA & Canada', suffix: '+' },
    { value: '10', label: 'Years of Excellence', suffix: '+' }
  ];

  return (
    <section className="relative py-16 bg-[#005B63]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-2">
                {stat.value}
                <span className="text-[#00A3B1]">{stat.suffix}</span>
              </div>
              <p className="text-white/80 text-sm">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutStats;
